module.exports = __webpack_public_path__ + "img/vignettes-asso_0001_adiflor.e13d4c31.jpg";